import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { CustomStyleService } from '../../services/custom-style.service';

import * as d3 from 'd3';

@Component({
  selector: 'donut-chart',
  templateUrl: './donut-chart.component.html',
  styleUrls: ['./donut-chart.component.scss']
})
export class DonutChartComponent implements OnInit {

  @ViewChild('svg') svg: ElementRef;

  @Input('value') value: number;
  @Input('label') label: number;

  constructor(private customStyleService: CustomStyleService) { }

  ngOnInit() {
    this.initChart(); // TODO: implement D3 data update in input changes
  }

  initChart() {
    let data: any = [this.value, 100 - this.value];

    let height, width;
    width = height = 150;
    const radius = height * 0.5;
    const hole = radius * 0.82;

    const colour = d3.scaleSequential(d3.interpolateRgb(
      d3.rgb('#efa85b'),
      d3.rgb(this.customStyleService.obj.colors.primary)
    ));

    const svg = d3.select(this.svg.nativeElement)
      .attr('viewBox', `0 0 ${height} ${height}`);

    const arcFill = svg.append('g')
      .attr('transform', 'translate(' + width / 2 + ',' + width / 2 + ')');

    const arcOutline = svg.append('g')
      .attr('transform', 'translate(' + width / 2 + ',' + width / 2 + ')');

    const arcText =  svg.append('g')
      .attr('transform', 'translate(' + width / 2 + ',' + width / 2 + ')');

    arcText.append('text')
      .attr('text-anchor', 'middle')
      .attr('dy', -2)
      .style('font-size', '1.5rem')
      .style('font-weight', 'bold')
      .style('fill', '#676a6c')
      .text(`${this.value}%`);

    arcText.append('text')
      .attr('text-anchor', 'middle')
      .attr('dy', 14)
      .style('fill', '#676a6c')
      .text(this.label);

    const arc: any = d3.arc()
      .innerRadius(hole)
      .outerRadius(radius);

    const pie = d3.pie()
      .sort(null)
      .value(function(d): any { return d; });

    data = pie(data);

    arcOutline.selectAll('.arc')
      .data(data)
      .enter()
      .append('path')
      .attr('class', 'arc')
      .attr('d', arc)
      .style('fill', function(d){
        return createGradient(d);
      })
      .style('stroke', 'white')
      .style('stroke-width', '3px');

    function createGradient(d) {

      const miniArcs = [];
      const angleExtent = d.endAngle - d.startAngle;
      const noOfArcs = angleExtent * 75; //seems like a good number

      colour.domain([0, noOfArcs]);
      const miniArcAngle = angleExtent / noOfArcs;

      for (let j = 0; j < noOfArcs; j++) {
        const miniArc: any = {};
        miniArc.startAngle = d.startAngle + (miniArcAngle * j);
        //0.01 so the colours overlap slightly, so there's no funny artefacts.
        miniArc.endAngle = miniArc.startAngle + miniArcAngle + 0.01;
        //unless it goes beyond the end of the parent arc
        miniArc.endAngle = miniArc.endAngle > d.endAngle ? d.endAngle : miniArc.endAngle;
        miniArcs.push(miniArc);
      }

      arcFill.selectAll('.mini-arc')
        .data(miniArcs)
        .enter()
        .append('g')
        .append('path')
        .attr('class', 'arc')
        .attr('d', arc)
        .style('fill', function(a, i){ return d.index === 0 ? colour(i) : '#ddd'; });

      return 'none';
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/donut-chart/donut-chart.component.ts